export const PROFILE_TABS = [
  {
    name: 'Header',
    key: 'header'
  },
  {
    name: 'Theme',
    key: 'theme'
  },
  {
    name: 'Social Links',
    key: 'social-links'
  },
  {
    name: 'Modules',
    key: 'modules'
  }
]

export const profileTabs = (isContentMenuEnabled: boolean) => [
  {
    name: 'Header',
    key: 'header'
  },
  {
    name: 'Theme',
    key: 'theme'
  },
  {
    name: 'Social Links',
    key: 'social-links'
  },
  isContentMenuEnabled
    ? {
        name: 'Content',
        key: 'modules'
      }
    : {
        name: 'Modules',
        key: 'modules'
      }
]

export const TALENT_PROFILE_ID = 'TALENT_PROFILE_ID'
